var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.501,
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    fontFamily: "Times New Roman",
    fontSize: 16,
    style: {
      fontVariantLigatures: "none"
    },
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    width: "1em",
    height: "1em",
    viewBox: "0 -48 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.282-5.302l2.704-2.704-6.98-6.98-2.704 2.704v3.178h3.802v3.802h3.178zm15.534-27.564c0-.437-.217-.653-.652-.654a.687.687 0 00-.505.208L10.56-17.213a.687.687 0 00-.208.505c0 .436.218.654.653.654.198 0 .366-.07.504-.208l16.099-16.099a.687.687 0 00.208-.505zm-1.603-5.703l12.356 12.356L13.856-1.5H1.5v-12.356l24.713-24.713zM46.5-35.718c0 1.05-.367 1.94-1.099 2.672l-4.93 4.933-12.358-12.358 4.933-4.9c.711-.753 1.603-1.129 2.672-1.129 1.05 0 1.951.376 2.703 1.129l6.98 6.95c.732.773 1.099 1.673 1.099 2.703z",
    fillRule: "nonzero",
    stroke: "none"
  })));
}

export default SvgPencil;